import { Box, Typography, Container } from '@mui/material';
import { useGlobalState } from "../contexts/GlobalState";
import { useEffect } from 'react';

export const DeviceManagement = () => {
    const { setBreadcrumbsText } = useGlobalState();

    useEffect(() => {
        setBreadcrumbsText(["Home", "Post-Season Module", "Device Management"]);
    }, []);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ textAlign: 'center', py: 8 }}>
                <Typography variant="h4" gutterBottom>
                    Device Management
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                    Device management options will be available here.
                </Typography>
            </Box>
        </Container>
    );
};
